import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './StoryCompletionPrompt.css';

const StoryCompletionPrompt = ({ onClose }) => {
  const { anonymousActivity, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  // Don't show if user is authenticated or the prompt was dismissed
  if (isAuthenticated || dismissed) {
    return null;
  }

  const handleCreateAccount = () => {
    navigate('/accounts/signup/');
  };

  const handleDismiss = () => {
    setDismissed(true);
    if (onClose) {
      onClose();
    }
  };

  return (
    <div className="story-completion-prompt">
      <div className="story-completion-content">
        <h2>Great job on your story!</h2>
        <p>Create an account to save this story and make more.</p>
        <div className="button-row">
          <button className="create-account-button" onClick={handleCreateAccount}>
            Create Account
          </button>
          <button className="maybe-later-button" onClick={handleDismiss}>
            Maybe Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default StoryCompletionPrompt;